module.exports = __webpack_public_path__ + "img/icon-lock-green.18ba0d41.svg";